import axios from "axios";
import { XMLParser } from 'fast-xml-parser'
export const parserXml = new XMLParser(); 

import { timeoutIntegration, urlApi, getApiUrl } from ".";
import { SecureStorage } from "@helpers/storage";

export function GetPlacaDetran(placa) {
    return new Promise((resolve, reject) => {
      let config = {
        method: 'post',
        url: 'http://mobiles2.erpcase.com.br/GetPlacaDetran/ConsultarPlacaDetran.asmx?op=GetPlacaDetran',
        headers: {
          'Content-Type': 'application/soap+xml; charset=utf-8'
        },
        data: `<?xml version="1.0" encoding="utf-8"?>\n<soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">\n  <soap12:Body>\n    <GetPlacaDetran xmlns="http://tempuri.org/">\n      <Placa>${placa}</Placa>\n      <senha>!@#$%</senha>\n    </GetPlacaDetran>\n  </soap12:Body>\n</soap12:Envelope>`
      };
  
      axios(config)
        .then(function (response) {
          const data = parserXml.parse(response.data)
          resolve(data["soap:Envelope"]["soap:Body"]["GetPlacaDetranResponse"]["GetPlacaDetranResult"]["diffgr:diffgram"]["NewDataSet"]["Table"])
        })
        .catch(function (error) {
          reject("Ocorreu um erro ao tentar buscar dados da placa")
        });
  
    });
  }
  
  export function GetVehiclesList(idContract) {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "get",
          url: getApiUrl(`/api/v1/ClientIntegration/VehiclesCliente`),
          headers: {
            Authorization: "Bearer " + token,
            vacancyId: idContract
          },
          timeout: timeoutIntegration

        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    });
  }
  
  export function AddVehicle(clientVehicle) {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "post",
          url: getApiUrl(`/api/v1/ClientIntegration/VehiclesCliente`),
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json-patch+json"
          },
          data: clientVehicle,
          timeout: timeoutIntegration
        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    });
  }
  
  export function DelVehicle(plate, idVehicle) {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "delete",
          url: getApiUrl(`/api/v1/ClientIntegration/VehiclesCliente`),
          headers: {
            Authorization: "Bearer " + token,
            plate: plate,
          },
          params: {
            idVehicle: idVehicle
          },
          timeout: timeoutIntegration
        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    });
  }

  export function DelMyVehicle(id){
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "delete",
          url: getApiUrl(`/api/v1/Vehicle/${id}`),
          headers: {
            Authorization: "Bearer " + token,
          },
          timeout: timeoutIntegration
        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    });
  }

  export function AddMyVehicle(myVehicle) {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "post",
          url: getApiUrl(`/api/v1/Vehicle`),
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json-patch+json"
          },
          data: myVehicle,
          timeout: timeoutIntegration
        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    });
  }

  export function GetMyVehicles() {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "get",
          url: getApiUrl(`/api/v1/Vehicle`),
          headers: {
            Authorization: "Bearer " + token,
          },
          timeout: timeoutIntegration

        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } 
            if (response.status == 204){
              resolve([])
            }
            else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    });
  }

  export function GetVehicleInYard() {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "get",
          url: getApiUrl(`/api/v1/Vehicle/GetVehicleInYard`),
          headers: {
            Authorization: "Bearer " + token,
          },
          timeout: timeoutIntegration

        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    });
  }

  export function AddOrderVehicle(integration, plate) {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "post",
          url: getApiUrl(`/api/v1/Vehicle/AddOrderVehicle`),
          headers: {
            Authorization: "Bearer " + token,
          },
          params: {
            "integration":integration,
            "plate": plate
          },
          timeout: timeoutIntegration
        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    });
  }

  export function GetOrderVehicleStatus(plate) {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "post",
          url: getApiUrl(`/api/v1/Vehicle/GetOrderVehicleStatus`),
          headers: {
            Authorization: "Bearer " + token,
          },
          params: {
            "plate": plate
          },
          timeout: timeoutIntegration
        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    });
  }